import { useEffect, useRef } from 'react'
import { useWebSocketContext } from '../context/WebSocketContext'

/**
 * Hook to receive WebSocket updates using the singleton WebSocket connection
 * @param {Function} onMessage - Callback function to handle messages
 * @returns {Object} - Connection state and methods
 */
export function useWebSocketUpdates(onMessage) {
  const { isConnected, connectionType, addListener, subscribeToJob, unsubscribeFromJob } = useWebSocketContext()
  const listenerIdRef = useRef(null)
  
  // Register message listener
  useEffect(() => {
    if (onMessage) {
      // Generate unique listener ID
      listenerIdRef.current = `listener-${Date.now()}-${Math.random()}`
      const removeListener = addListener(listenerIdRef.current, onMessage)
      
      return () => {
        removeListener()
      }
    }
  }, [onMessage, addListener])
  
  return {
    isConnected,
    connectionType,
    subscribeToJob,
    unsubscribeFromJob
  }
}